import { ActiveSubversion } from '../interfaces/Organization';

export class MActiveSubversion{
    public id: number;
    public moduleVersionId: number;
    public url: string;
    public updateDate: string;

    constructor(sub: ActiveSubversion){
        this.id = sub.id;
        this.moduleVersionId = sub.version_modulo_id;
        this.url = sub.url;
        this.updateDate = sub.fecha_actualizacion
    }
}